import { render, staticRenderFns } from "./MovieList.vue?vue&type=template&id=002bb95e&scoped=true&"
import script from "./MovieList.vue?vue&type=script&lang=js&"
export * from "./MovieList.vue?vue&type=script&lang=js&"
import style0 from "./MovieList.vue?vue&type=style&index=0&id=002bb95e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002bb95e",
  null
  
)

export default component.exports